import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { projectHeading } from "./data/PorjectData";
import { blogHeading, blogsSlidesData, categoryLabels } from "./data/blogsData";
import { testimonialContent, testimonials } from "./data/testimonailsData";
import {
  DevelopmentServicesContent,
  DevelopmentServicesData,
} from "./data/developmentServicesTabsData";
import {
  bannerContent,
  CoverTheStack,
  TypesOfBuildData,
  WebAppservicesRoadMap,
  webDevPageIndustriesSection,
  WebServicesFaqData,
  WebServicesHighvaluesData,
  WhoWeServeData,
  WhyChooseBitsclanData,
} from "./data/web-app-services-data";

import { engagementModelContent } from "./data/engagementModelContent";
import tabData, {
  BannerDataEn,
  staticHeading,
  hireContactIndustriesSectionContentEn,
  pioneerChangeSectionContent,
  slidesData,
  industriesContent,
} from "./data/industryData";
import { lifeAtBitsclanData } from "./data/lifeAtBitsclanData";
import {
  CustomDevelopmentIndustriesHeading,
  customDevelopmentPageRoadMapData,
  CustomDevelopmentPageServicesData,
  customDevPageBannerData,
  customDevPageCoverTheStack,
  CustomDevPageFaqData,
  customDevPageHighvaluesData,
  CustomDevPageTypesOfBuildData,
  CustomDevPageWhoWeServeData,
  CustomDevPageWhyChooseBitsclanData,
} from "./data/custom-development-data";

import {
  DevOpsBannerContent,
  devOpsCoverTheStack,
  DevOpsFaqData,
  devOpsPageHireUsData,
  devOpsProcessStepsData,
  devOpsRoadMapContent,
  devOpsServices,
  devOpsSolutionsData,
  PionerChangeHeadings,
  WhyChoseUsData,
} from "./data/dev-ops-data";

import {
  AnalyticsHighvaluesData,
  AnalyticsWhoWeServeData,
  AnalyticsWhyChooseBitsclanData,
  DataAnalyticsBannerContent,
  dataAnalyticsCoverTheStackData,
  DataAnalyticsTypesOfBuildSection,
  DataAndAnalyticsServicesData,
  faqData,
  industriesHeading,
} from "./data/dataAnalyticsPageData";
import { analyticsData } from "./data/analayticsSolutionData";
import {
  EngagementModelPageBannerDataEn,
  engagmentModelPageData,
} from "./data/engagementModelPageData";
import megaMenuContent from "./data/megaMenuData";
import footerContent from "./data/footerData";
import contactSectionComponent from "./data/contactSectionComponentData";
import {
  solutionsData,
  mainBannerImg,
  servicesData,
  steps,
  facts,
  hiringDetails,
  tabs,
  tabItems,
  techCombinations,
  schemaData,
  hireRubyAndRailsPageContent,
  hirefaqData, // Import the main content object
} from "./data/hire-ruby-and-rails.data";

import { WebServicesIndustryTabsData } from "./data/industries-tab-section-data";

import { roadMapCommonData } from "./data/road-map-common-data";

import {
  aiDevBannerContent,
  aiDevCoverTheStack,
  aiDevelopmentBoxContent,
  AiDevelopmentServicesData,
  AiDevPageFaqData,
  AIDevPageSolutionsSection,
  AIDevRoadmapContent,
  AIDevWhyUsContent,
  aiPowerSectionContent,
  IndustriesSectionContent,
} from "./data/ai-development-data";

import {
  frequentlyAskedQuestionData,
  mobileAppCoverTheStack,
  mobileAppDevelopmetServices,
  mobileAppHighvaluesData,
  mobileAppIndustriesHeading,
  mobileAppPageBanner,
  mobileAppRoadMapHeadings,
  mobileAppTypesOfBuildData,
  mobileAppWhoWeServeData,
  mobileAppWhyChoseUs,
} from "./data/mobile-app-development-data";

import {
  SaqDevelopmentServicesData,
  sqaCoverTheStack,
  sqaFaqData,
  sqaHighvaluesData,
  sqaIndustriesHeading,
  sqaPageBanner,
  sqaRoadMapData,
  sqaTypesOfBuildData,
  sqaWhoWeServeData,
  sqaWhyChooseBitsclanData,
} from "./data/software-quality-assurence-data";
import {
  BlockchainBannerContent,
  BlockchainCoverTheStack,
  BlockchainDevelopmentServicesData,
  BlockchainFaqData,
  BlockchainHighvaluesData,
  BlockchainIndustriesHeading,
  BlockchainProcessStepsData,
  BlockchainRoadMapData,
  BlockchainWhoWeServeData,
  BlockchainWhyChooseBitsclanData,
} from "./data/blockchainPageData";

import { KsaHomeData } from "./data/ksaHomeData";
import { hireDjangoPageData } from "./data/hire-django-data";

import {
  CybersecurityBannerContent,
  cyberSecurityCoverTheStack,
  cyberSecurityDevelopmentServicesData,
  cyberSecurityFaqData,
  cyberSecurityHighvaluesData,
  cyberSecurityIndustriesHeading,
  CybersecurityRoadmapData,
  cyberSecurityTypesOfBuildData,
  cyberSecurityWhoWeServeData,
  cyberSecurityWhyChooseBitsclanData,
} from "./data/cyber-security-data";

import {
  HireAngularBannerDataEn,
  hireAngularCoverTheStackEn,
  hireAngularEnagementModelEn,
  HireAngularFactsDataEn,
  HireAngularFaqDataEn,
  HireAngularServicesDataEn,
  HireAngularSolutionsDataEn,
  HireAngularStepsEn,
  hireAppContentEn,
  mainBannerImgAngular,
  techCombinationsEn,
} from "./data/hireAngularPagedata";

import { hireGoLangContent } from "./data/hire-goLang-data";
import { hireFlutterPageContent } from "./data/hireFlutterPageData";
import { hireMernStackPageContent } from "./data/hireMernstackPageData";
import { hireJavascriptPageContent } from "./data/hire-javascript-data";

import { hireAndroidDeveloper } from "./data/hireAndroidPageData";
import { hireNodePageContent } from "./data/hireNodejsPageData";

// COMBINED REACT IMPORTS
import {
  hireAppIdesContentEn,
  hireReactBannerContentEn,
  hireReactCombinationsEn,
  hireReactCoverTheStackEn,
  hireReactExpertFactsEn,
  hireReactPageEngagementModelsEn,
  hireReactServicesDataEn,
  hireReactSolutionsDataEn,
  hireReactStepsEn,
  mainBannerImgReact,
  reactFaqContentEn,
} from "./data/hire-reactjs-data";

import {
  coverTheStackPythonEn,
  factIdeaEn,
  hirePythonBannerContentEn,
  hirePythonCombinationsEn,
  hirePythonExpertiseEn,
  hirePythonFactsDataEn,
  hirePythonFaqDataEn,
  hirePythonPageContentEn,
  hirePythonPerformanceEn,
  hirePythonStepsEn,
  mainBannerImgPython,
} from "./data/hire-python-data";
import { cookiesObj, privacyPolicyObj } from "./data/modalData";

import { portfolioPageData } from "./data/portfolioPageData";
import {
  caseStudiesContentEn,
  caseStudyBannerEn,
} from "./data/case-studies-data";

import { aiContactData } from "./data/aiContactSectionData";
import { metaTitlesEn } from "./data/meta-titles-en";
import { privacyPolicyContentEn } from "./data/privacy-policy-data-en";
import { termsAndConditionsContentEn } from "./data/terms-and-conditions-en";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      portfolio: projectHeading,
      blogs: {
        blogsSlideData: blogsSlidesData,
        blogsHeadings: blogHeading,
        categoryLabels: categoryLabels,
      },
      testimonials: {
        testimonialContent: testimonialContent,
        testimonialArray: testimonials,
      },
      developmentServicesSectionData: {
        developmentServicesContent: DevelopmentServicesContent,
        developmentServicesTabs: DevelopmentServicesData,
      },
      engagementModelContent: engagementModelContent,
      industryTabsSection: WebServicesIndustryTabsData,
      webAppDevelopmentPage: {
        webAppDevelopmentPageBanner: bannerContent,
        webDevPageKeyFeature: TypesOfBuildData,
        webDevWhoWeServeSection: WhoWeServeData,
        webDevPageWhyChoseBitsclan: WhyChooseBitsclanData,
        webDevPageHighValuesData: WebServicesHighvaluesData,
        webDevPageFaqs: WebServicesFaqData,
        webDevPageIndustriesHeading: webDevPageIndustriesSection,
        webDevPageCoverTheStack: CoverTheStack,
        webDevPageRoadMap: WebAppservicesRoadMap,
      },
      industries: {
        tabData: tabData,
        sliderData: slidesData,
        pioneerChangeSectionData: pioneerChangeSectionContent,
        bannerContent: BannerDataEn,
        hireContactIndustriesSection: hireContactIndustriesSectionContentEn,
        staticHeading: staticHeading,
        newIndustriesSection: industriesContent,
      },
      lifeAtBitsclan: lifeAtBitsclanData,
      customDevelopmentPage: {
        customDevPageBanner: customDevPageBannerData,
        customDevPageDevelopmentSerivces: CustomDevelopmentPageServicesData,
        customDevPageTypesOfBuild: CustomDevPageTypesOfBuildData,
        customDevPageWhoWeServeSection: CustomDevPageWhoWeServeData,
        customDevPageWhyChoseUsSection: CustomDevPageWhyChooseBitsclanData,
        customDevPageHighValueSection: customDevPageHighvaluesData,
        customDevPageRoadMapSection: customDevelopmentPageRoadMapData,
        customDevPageCoverTheStack: customDevPageCoverTheStack,
        customDevPageIndustryHeading: CustomDevelopmentIndustriesHeading,
        customDevPageFaqSection: CustomDevPageFaqData,
      },
      devOpsPage: {
        devOpsPageBanner: DevOpsBannerContent,
        devOpsPageServices: devOpsServices,
        devOpsPageProcessSteps: devOpsProcessStepsData,
        devOpsHireUsSection: devOpsPageHireUsData,
        devOpsSolutionCardSection: devOpsSolutionsData,
        devOpsPageRoadMap: devOpsRoadMapContent,
        devOpsPageCoverTheStack: devOpsCoverTheStack,
        devOpsPageWhyChoseUs: WhyChoseUsData,
        devOpsPageFaqS: DevOpsFaqData,
        devOpsPagePioneerHeading: PionerChangeHeadings,
      },
      dataAndAnylyticsPage: {
        dataAnylyticsBanner: DataAnalyticsBannerContent,
        dataAndAnylyticsServices: DataAndAnalyticsServicesData,
        dataAndAnylyticsTypeOfBuild: DataAnalyticsTypesOfBuildSection,
        dataAndAnylyticsWhoWeServe: AnalyticsWhoWeServeData,
        dataAndAnylyticsWhyChoseUs: AnalyticsWhyChooseBitsclanData,
        dataAndAnylyticsHighValueFeatures: AnalyticsHighvaluesData,
        dataAnalyticsCoverTheStackSection: dataAnalyticsCoverTheStackData,
        dataAnalyticsIndustriesHeading: industriesHeading,
        dataAnalyticsfaqSection: faqData,
      },
      roadMapCommonContent: roadMapCommonData,
      analyticsSolutionContent: analyticsData,
      engagementModelPage: engagmentModelPageData,
      engagementModelBannerContent: EngagementModelPageBannerDataEn,
      headerMegaMenu: megaMenuContent,
      footer: footerContent,
      contactSection: contactSectionComponent,
      hireRubyAndRailsPage: {
        solutionsDataContent: solutionsData,
        faqDataContent: hirefaqData,
        mainBannerImgContent: mainBannerImg,
        servicesDataContent: servicesData,
        stepsContent: steps,
        factsContent: facts,
        hiringDetailsContent: hiringDetails,
        tabsContent: tabs,
        tabItemsContent: tabItems,
        techCombinationsContent: techCombinations,
        schemaDataContent: schemaData,
        hireRubyAndRailsPageContentData: hireRubyAndRailsPageContent,
      },
      aiDevelopmentPageContent: {
        aiDevBanner: aiDevBannerContent,
        aiPowerSection: aiPowerSectionContent,
        aiDevelopmentServices: AiDevelopmentServicesData,
        notOnlyAiCompanySection: aiDevelopmentBoxContent,
        industriesSectionContent: IndustriesSectionContent,
        FutureSoltionContent: AIDevPageSolutionsSection,
        aiDevWhyUsContent: AIDevWhyUsContent,
        aiDevRoadMapSection: AIDevRoadmapContent,
        aiDevCoverTheStackSection: aiDevCoverTheStack,
        aiDevFaqSection: AiDevPageFaqData,
      },
      mobileAppDevelopmentPage: {
        mobileAppBanner: mobileAppPageBanner,
        mobileAppServicesSection: mobileAppDevelopmetServices,
        mobileAppTypeOfBuildSection: mobileAppTypesOfBuildData,
        mobileAppWhoWeServeSection: mobileAppWhoWeServeData,
        mobileAppWhyChooseUsSection: mobileAppWhyChoseUs,
        mobileAppHighValueSection: mobileAppHighvaluesData,
        mobileAppRoadMapSection: mobileAppRoadMapHeadings,
        mobileAppCoverTheStack: mobileAppCoverTheStack,
        mobileAppIndustriesHeading: mobileAppIndustriesHeading,
        mobileAppFaqSection: frequentlyAskedQuestionData,
      },
      softwareQualityAssurencePage: {
        pageBanner: sqaPageBanner,
        pageServicesData: SaqDevelopmentServicesData,
        pageTypesOfBuildData: sqaTypesOfBuildData,
        pageWhoWeServeCards: sqaWhoWeServeData,
        pageChooseUs: sqaWhyChooseBitsclanData,
        pageHighValueCards: sqaHighvaluesData,
        pageRoadMap: sqaRoadMapData,
        pageCoverTheStack: sqaCoverTheStack,
        pageIndustriesHeading: sqaIndustriesHeading,
        pageFaqData: sqaFaqData,
      },
      BlockChainAnalyticsPage: {
        pageBanner: BlockchainBannerContent,
        pageServicesData: BlockchainDevelopmentServicesData,
        pageProcessStepsData: BlockchainProcessStepsData,
        pageWhoServeData: BlockchainWhoWeServeData,
        pageWhyChooseUsData: BlockchainWhyChooseBitsclanData,
        pageHighValueData: BlockchainHighvaluesData,
        pageRoadMapData: BlockchainRoadMapData,
        pageCoverTheStack: BlockchainCoverTheStack,
        pageIndustriesHeading: BlockchainIndustriesHeading,
        pageFaq: BlockchainFaqData,
      },
      headerMegaMenu: megaMenuContent,
      ksaHome: KsaHomeData,
      hireDjangoPage: hireDjangoPageData,
      cybersecurityPage: {
        pageBanner: CybersecurityBannerContent,
        pageServicesData: cyberSecurityDevelopmentServicesData,
        pageAccordianData: cyberSecurityTypesOfBuildData,
        pageWhoServeData: cyberSecurityWhoWeServeData,
        pageWhyChooseUsData: cyberSecurityWhyChooseBitsclanData,
        pageHighValueData: cyberSecurityHighvaluesData,
        pageRoadMapData: CybersecurityRoadmapData,
        pageCoverTheStack: cyberSecurityCoverTheStack,
        pageIndustriesHeading: cyberSecurityIndustriesHeading,
        pageFaqData: cyberSecurityFaqData,
      },
      hireAngularPage: {
        bannerData: HireAngularBannerDataEn,
        servicesData: HireAngularServicesDataEn,
        solutionData: HireAngularSolutionsDataEn,
        combinationData: techCombinationsEn,
        pageStepsData: HireAngularStepsEn,
        coverTheStackData: hireAngularCoverTheStackEn,
        factsData: HireAngularFactsDataEn,
        appIdeaData: hireAppContentEn,
        faqData: HireAngularFaqDataEn,
        hirePageEngagmentModelSection: hireAngularEnagementModelEn,
        mainBannerImgData: mainBannerImgAngular,
      },
      hireReactPage: {
        bannerData: hireReactBannerContentEn,
        servicesData: hireReactServicesDataEn,
        solutionData: hireReactSolutionsDataEn, // This was duplicated, removed from the top-level
        combinationData: hireReactCombinationsEn, // Added from the second import
        stepsData: hireReactStepsEn, // Added from the second import
        coverTheStackData: hireReactCoverTheStackEn, // Added from the second import
        factsData: hireReactExpertFactsEn, // Added from the second import
        appIdeaData: hireAppIdesContentEn, // Added from the second import
        pageEngagmentModels: hireReactPageEngagementModelsEn, // Added from the second import
        faqData: reactFaqContentEn, // Added from the second import
        mainBannerImgData: mainBannerImgReact,
      },
      hireGoLangPageContent: hireGoLangContent,
      hireFlutterPage: hireFlutterPageContent,
      hireMernStackPage: hireMernStackPageContent,
      hireJavascriptPage: hireJavascriptPageContent,
      hireAndroidPage: hireAndroidDeveloper,
      hireNodePage: hireNodePageContent,
      hirePythonPage: {
        bannerContent: hirePythonBannerContentEn,
        servicesData: hirePythonExpertiseEn,
        developmentPerformaceData: hirePythonPerformanceEn,
        combinationData: hirePythonCombinationsEn,
        stepsData: hirePythonStepsEn,
        coverTheStackData: coverTheStackPythonEn,
        factsData: hirePythonFactsDataEn,
        appIdeaData: factIdeaEn,
        engagementModelContent: hirePythonPageContentEn,
        faqsSection: hirePythonFaqDataEn,
        mainBannerImgData: mainBannerImgPython,
      },
      modalsContent: {
        privacyPolicyModal: privacyPolicyObj,
        cookiesModal: cookiesObj,
      },
      portfolioPage: portfolioPageData,
      caseStudiesPage: {
        caseStudyBanner: caseStudyBannerEn,
        caseStudies: caseStudiesContentEn,
      },
      aiSectionData: { aiSection: aiContactData },
      metaTitles: metaTitlesEn,
      privacyPolicyPage: privacyPolicyContentEn,
      termsAndConditionsPage: termsAndConditionsContentEn,
    },
  },
  // English only. The Arabic translation and its ~40 data files were removed;
  // there is no second language to select, so nothing reads localStorage or
  // switches at runtime any more.
  lng: "en",
  fallbackLng: "en",
  ns: [
    "portfolio",
    "blogs",
    "testimonials",
    "developmentServicesSectionData",
    "webAppDevelopmentPage",
    "engagementModelContent",
    "industries",
    "lifeAtBitsclan",
    "customDevelopmentPage",
    "devOpsPage",
    "dataAndAnylyticsPage",
    "analyticsSolutionContent",
    "engagementModelPage",
    "headerMegaMenu",
    "footer",
    "industryTabsSection",
    "roadMapCommonContent",
    "aiDevelopmentPageContent",
    "mobileAppDevelopmentPage",
    "softwareQualityAssurencePage",
    "BlockChainAnalyticsPage",
    "contactSection",
    "hireRubyAndRailsPage",
    "engagementModelPage",
    "headerMegaMenu",
    "ksaHome",
    "engagementModelBannerContent",
    "hireAngularPage",
    "hireReactPage",
    "hireDjangoPage",
    "hireGoLangPageContent",
    "hireFlutterPage",
    "hireJavascriptPage",
    "hireAndroidPage",
    "hireNodePage",
    "hirePythonPage",
    "portfolioPage",
    "modalsContent",
    "caseStudiesPage",
    "aiSectionData",
  ], // namespaces (your file names)
  interpolation: { escapeValue: false },
});

export default i18n;
